export default __webpack_public_path__ + "static/media/pc03-2.58057373.png";